import component from './i18nEntityTypes.vue'

export default component
